<div class="container-fluid pb-2 text-grey">
  <form [formGroup]="settingsForm" class="scrollable-form">
    <div class="d-flex flex-column h-100">
      <div formArrayName="entities" class="row mb-2 overflow-auto">
        <div *ngFor="let entity of entities.controls; let i = index" [formGroupName]="i" class="col-md-4 mb-4">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0" style="font-weight:700">{{ entity.get('name').value }}</h3>
            </div>
            <div formArrayName="setting" class="card-body">
              <div *ngFor="let setting of entity.get('setting').controls; let j = index" [formGroupName]="j" class="d-flex justify-content-between align-items-center mb-3 border p-2 rounded">
                <div class="setting-name text-grey" style="font-weight:700">{{ setting.get('name').value }}</div>
                <div class="setting-status">
                  <mat-slide-toggle [formControl]="setting.get('value')"
                                    [disabled]="isReader || setting.get('disabled').value"
                                    (change)="onSettingChange(i, j, $event.checked)">
                                    <span class="text-grey">
                                      {{ setting.get('value').value ? 'Enabled' : 'Disabled' }}
                                    </span>
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-panel" *ngIf="isReader == false">
        <button class="default-btn" type="button" title="Save the changes." (click)="openConfirmDialog()" [disabled]="isReader">
          <!-- Disable Save button if reader -->
          <span class="bi bi-save" aria-hidden="True" style="margin-right: 10px"></span>Save
        </button>
      </div>
    </div>
  </form>
</div>

<ng-template #loading>
  <p>Loading or no settings available...</p>
</ng-template>

<ng-template #confirmDialog>
  <h1 mat-dialog-title>Save Changes</h1>
  <div mat-dialog-content>
    <p>Do you want to save applied changes?</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onConfirmNo()">No</button>
    <button mat-button cdkFocusInitial (click)="onConfirmYes()">Yes</button>
  </div>
</ng-template>
